import { Elements } from '@stripe/react-stripe-js';
import Modal from '@/components/Modals/Core';
import SidebarModal from '@/components/Modals/Sidebar';
import { SidebarHeaderProvider } from '@/components/Modals/Sidebar/context/SidebarHeaderContext';
import { getStripe } from '@/stripe';
import { UpgradePlanModalHeader } from './header';
import UpgradePlanModalScreens from './screens';
import { UpgradePlanModalScreenName } from './types';
import type { Plan } from '@/fixtures/plans';
import type { ProrationBillingMode } from '@/hooks/billing/useProration';
export interface UpgradePlanModalProps {
  billingModeOverride?: ProrationBillingMode;
  children?: React.ReactNode;
  initial?: UpgradePlanModalScreenName;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  plan: Plan['name'];
}
const UpgradePlanModal = ({
  open,
  onOpenChange,
  children,
  initial = UpgradePlanModalScreenName.UpgradePlan,
  billingModeOverride,
  plan
}: UpgradePlanModalProps) => {
  return <Elements stripe={getStripe()} data-sentry-element="Elements" data-sentry-component="UpgradePlanModal" data-sentry-source-file="modal.tsx">
      <SidebarHeaderProvider data-sentry-element="SidebarHeaderProvider" data-sentry-source-file="modal.tsx">
        <SidebarModal onOpenChange={onOpenChange} open={open} trigger={children} data-sentry-element="SidebarModal" data-sentry-source-file="modal.tsx">
          {/*
           * Initial screen can be inferred, but setting it
           * explicitly prevents framer motion from animating
           * the first screen in.
           */}
          <Modal.ScreenContainer initial={initial} data-sentry-element="Modal.ScreenContainer" data-sentry-source-file="modal.tsx">
            <UpgradePlanModalHeader data-sentry-element="UpgradePlanModalHeader" data-sentry-source-file="modal.tsx" />
            <UpgradePlanModalScreens billingModeOverride={billingModeOverride} plan={plan} data-sentry-element="UpgradePlanModalScreens" data-sentry-source-file="modal.tsx" />
          </Modal.ScreenContainer>
        </SidebarModal>
      </SidebarHeaderProvider>
    </Elements>;
};
export default UpgradePlanModal;